import {toast} from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import './toaster.scss';

function ToasterWithMessage(){
    const error = (message: string,delay=2000) => {
        toast.error(message,{
          autoClose: delay,
          //prevent duplicate toaster
          toastId: `error-${message}`,
        });
        return true;
      };

      const success = (message: string,delay=2000) => {
        toast.success(message,{
          autoClose: delay,
          //prevent duplicate toaster
          toastId: `success-${message}`,
        });
        return true;
      };

      const warning = (message: string,delay=2000) => {
        toast.warning(message,{
          autoClose: delay,
          //prevent duplicate toaster
          toastId: `warning-${message}`,
        });
        return true;
      };

      const info = (message: string, delay = 2000) => {
        toast.info(message, {
          autoClose: delay,
          //prevent duplicate toaster
          toastId: `info-${message}`,
        });
        return true;
      };

      return { error, success, warning, info };
}


export default ToasterWithMessage;
